(function ($) {
    //on load
    $(window).on("load", function () {
    });
    $(document).ready(function () {

        if ($('.delivery-page').length && window.location.hash) {
            let scrollToElement = $(`.dynamic-block h2.title${window.location.hash}`);
            if (scrollToElement.length)
                $('html, body').animate({scrollTop: scrollToElement.offset().top - $('header.header').outerHeight() + 65}, 1000);
        }

        var globalLang = $('html').attr('lang');
        var testFile = [];
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });

        $('.submit-form-btn').on('click', function (e) {
            e.preventDefault();
            submitForm($(this).get(0));
        });

        $('.submit-form-btn-file').on('click', function (e) {
            e.preventDefault();
            submitFormFile($(this).get(0));
        });

        function submitFormFile(parentThat) {

            let formId = $(parentThat).data('form-id');
            let form = $('#' + formId);

            if (form.length < 1) {
                return;
            }

            let fileInput2 = testFile;

            let fileInput = form.find('input[type=file].upload-file');

            form.find('input, textarea').parent().removeClass('invalidInput');
            form.find('span.form__input__invalidText').remove();

            $('span.review__invalidInput').html('');
            let serializeArray = form.serializeArray();
            var data = new FormData();

            for (let i = 0; i < serializeArray.length; i++) {
                data.append(serializeArray[i].name, serializeArray[i].value);
            }

            if (fileInput2.length > 0) {
                let files = fileInput2;
                for (let i = 0; i < files.length; i++) {
                    if (files[i] != undefined) {
                        data.append('image[]', files[i]);
                    }
                }
            }

            let submitBtn = form.find('button[type="submit"]');

            form.submit(function (event) {
                event.preventDefault();
            });

            $.ajax({
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                cache: false,
                method: "POST",
                url: form.attr('action'),
                beforeSend: function () {
                    submitBtn.addClass('loading');
                },
                data: data
            })
                .success(function (response) {

                    submitBtn.removeClass('loading');

                    if (response.status) {
                        if (response.redirect)
                            window.location.href = response.redirect;

                        form.find('input, textarea').val('');
                        form.find('input, textarea').removeClass('invalidInput');
                        if (response.messageSended && response.status) {
                            $('.modal-success-text').html(response.msg);

                            $('#ex1').modal({
                                closeExisting: true
                            });

                        } else {
                            $('#ex1').modal({
                                closeExisting: true
                            });
                        }

                        setTimeout(function () {
                            submitBtn.removeClass('added');
                        }, 1000);
                    } else {
                        submitBtn.addClass('error');
                        setTimeout(function () {
                            submitBtn.removeClass('error');
                        }, 1000);
                        if (response.validator && response.msg) {

                            if (response.msg.e.image != undefined && response.msg.e.image.length) {
                                $('.parent-image').next('span.review__invalidInput').addClass('review__invalidInput');
                                $('.parent-image').next('span.review__invalidInput').html(response.msg.e.image[0]);
                            }

                            $.each(response.msg.e, function (ObjNames, ObjValues) {
                                let field = form.find("[name='" + ObjNames + "']");

                                if (field.length > 0) {
                                    $(field).parent().removeClass('invalidInput');
                                    field.after('<span class="form__input__invalidText ' + ObjNames + '">' + ObjValues + '</span>');
                                    $(field).parent().addClass('invalidInput');
                                }
                            });


                        }
                    }
                })
                .fail(function (response) {
                    submitBtn.addClass('error');

                    setTimeout(function () {
                        submitBtn.removeClass('error');
                    }, 1000);
                });
        }

        function submitForm(parentThat) {
            let formId = $(parentThat).data('form-id');
            let form = $('#' + formId);
            if (form.length < 1) {
                return;
            }

            let submitBtn = form.find('.submit-form-btn');

            form.submit(function (event) {
                event.preventDefault();
            });

            let serializedForm = form.find("select, textarea, input").serializeArray();

            form.find('input, textarea').parent().removeClass('invalidInput');
            form.find('span.form__input__invalidText').remove();

            $('div.invalidInput').removeClass('invalidInput');
            $('span.form__input__invalidText').remove();

            $.ajax({
                method: "POST",
                url: form.attr('action'),
                beforeSend: function () {
                    submitBtn.addClass('loading');
                },
                data: serializedForm
            })
                .success(function (response) {

                    submitBtn.removeClass('loading');

                    if (response.messageSended && response.status) {

                        $('.modal-success-text').html(response.msg);

                        $('#ex1').modal({
                            closeExisting: true
                        });
                    }

                    if (response.form) {
                        $(function () {
                            $(response.form).appendTo('body').submit().remove();
                        });
                    }

                    if (response.status) {
                        if (response.redirect)
                            window.location.href = response.redirect;

                        submitBtn.addClass('added');

                        form.find('input, textarea').val('');
                        form.find('input, textarea').removeClass('invalidInput');

                        setTimeout(function () {
                            submitBtn.removeClass('added');
                        }, 1000);
                    } else {
                        submitBtn.addClass('error');

                        setTimeout(function () {
                            submitBtn.removeClass('error');
                        }, 1000);

                        if (response.validator && response.msg) {
                            $.each(response.msg.e, function (ObjNames, ObjValues) {
                                let field = form.find("[name='" + ObjNames + "']");

                                if (field.length > 0) {
                                    if (ObjNames == 'terms_condition') {
                                        $('.terms div').after('<span class="form__input__invalidText ' + ObjNames + '">' + ObjValues + '</span>');
                                        $('.terms').addClass('invalidInput');
                                    } else {
                                        field.after('<span class="form__input__invalidText ' + ObjNames + '">' + ObjValues + '</span>');
                                        $(field).parent().addClass('invalidInput');
                                    }
                                }

                            });

                            if (form.find('.invalidInput').first().length > 0)
                                $('html, body').animate({scrollTop: form.find('.invalidInput').first().offset().top - 300}, 1000);

                        }

                    }
                })
                .fail(function (response) {
                    submitBtn.addClass('error');

                    setTimeout(function () {
                        submitBtn.removeClass('error');
                    }, 1000);
                });
        }

        //header input
        $(".searchIconMobile").click(() => {
            $(".mobileSearch").fadeToggle();
        });

        $(".cancelSearchIcon").click(() => {
            $(".mobileSearchInput").val("");
        });

        //time picker
        if ($(".timepick1").length) {
            $(".timepick1").timepicker();
        }

        /*	slider
            var swiper = new Swiper("#swiper1", {
                // loop: true,
                freemode: true,
                slidesPerView: 7,
                setWrapperSize: 120,
                center: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                breakpoints: {
                    1280: {
                        slidesPerView: 6
                    },
                    1024: {
                        slidesPerView: 5
                    },
                    768: {
                        slidesPerView: 3
                    },
                    480: {
                        slidesPerView: 2
                    }
                }
            });
            if(swiper.loopedSlides < 7 && window.innerWidth > 768) {
                $('#swiper1').find('.swiper-wrapper').addClass('static');
                $('.swiper-button-prev').remove();
                $('.swiper-button-next').remove();
                setTimeout(function () {
                    swiper.destroy();

                }, 100)

    */


        $(".carousel-slider").slick({
            slidesToShow: 7,
            arrows: true,
            responsive: [
                {
                    breakpoint: 955,
                    settings: {
                        slidesToShow: 3

                    },
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3

                    },
                }
            ]
        });

        $(".block-empty").hide();

        $(".carousel-slider").show();

        $(".review_slide").slick({
            slidesToShow: 2,
            arrow: true,
            prevArrow: $(".swiper2-button-prev"),
            nextArrow: $(".swiper2-button-next")
        });

        //slider
        // let swiper2 = new Swiper("#sgit wiper2", {
        // 	loop: true,
        // 	slidesPerView: 2,
        // 	center: true,
        // 	navigation: {
        // 		nextEl: ".swiper2-button-next",
        // 		prevEl: ".swiper2-button-prev"
        // 	}
        // });
        //slider
        $(".slider3").slick({
            slidesToShow: 5,
            initialSlide: 2,
            variableWidth: true,
            centerMode: true,
            arrow: false,
            responsive: [
                {
                    breakpoint: 1055,
                    settings: {
                        infinite: true,
                        slidesToShow: 3,
                        initialSlide: 2,
                        swipeToSlide: true,
                        centerMode: true,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });
        $(".slider3").on("breakpoint", (event, slick, breakpoint) => {
            slick.currentSlide = 2;
        });
        //slider
        $(".slider4").slick({
            slidesToShow: 1,
            arrows: false,
            dots: true
        });

        let carouselHeight = $(".carousel").offset().top;
        let navbarHeight = $(".navigation").height();

        $(window).scroll(() => {
            let scrollTop = $(this).scrollTop();
            if (scrollTop >= carouselHeight) {
                $(".carousel").addClass("sticky");
                $(".sticky_space").addClass("active");
            } else {
                $(".carousel").removeClass("sticky");
                $(".sticky_space").removeClass("active");

            }
        });
        //carousel dropdown controller
        $(document).on("click", ".slider-item", e => {
            console.log(1);
            let item = $(e.currentTarget).data("item");

            if ($(`.dropdown[data-item="${item}"]`).hasClass('dropdown-active')) {
                $(".dropdown").removeClass("dropdown-active");
            } else {
                $(".dropdown").removeClass("dropdown-active");
                $(`.dropdown[data-item="${item}"]`).addClass("dropdown-active");
            }
        });

        //filter dropdown
        $(".filter-btn").click(() => {
            $(".filter-dropdown").slideToggle();
        });
        $(".filter-dropdown__title").click(e => {
            $(e.currentTarget)
                .parent()
                .find(".filter-dropdown__list")
                .slideToggle();
        });
        //LANGUAGE DROPDOWN
        $(".navigation-lang").click(() => {
            $(".navigation-lang-drop").toggle();
        });

        //hide on click if not in range
        $(document).click(e => {
            if (!$(e.target).parents(".carousel").length) {
                $(".dropdown").removeClass("dropdown-active");
                $(".dropdown").slideUp(200);

                $(".carousel-text-active").removeClass("carousel-text-active");
            }
            if (!$(e.target).parents(".filter").length) {
                $(".filter-dropdown").hide();
            }
            if (
                !$(e.target)
                    .parent()
                    .hasClass("navigation-lang")
            ) {
                $(".navigation-lang-drop").hide();
            }
        });

        //fancy box
        $(".image__zoom").fancybox();

        //datapicker
        $("#datepicker").datepicker();

        //product slider
        $("#sliderProductShow").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: "#sliderProduct"
        });

        $('.fake_product_slider').hide();
        $('#sliderProductShow').show();


        $("#sliderProduct").slick({
            infinite: true,
            asNavFor: "#sliderProductShow",
            // centerMode: true,
            focusOnSelect: true,
            variableWidth: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            // prevArrow: $(".slick-prev"),
            // nextArrow: $(".slick-next")
        });

        $('.fake-slider').hide();
        $('.product__slider__wrap').show();

        //same slider
        $(".same__slider").slick({
            variableWidth: true,
            slidesToShow: 3,
            infinite: true,
            slidesToScroll: 1,
            swipeToSlide: true,
            prevArrow: $(".same-prev"),
            nextArrow: $(".same-next"),
            responsive: [
                {
                    breakpoint: 1055,
                    settings: {
                        slidesToShow: 3,
                        centerMode: true,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });

        //Modal slider only on checkout page
        if (location.pathname.includes('cart')) {

            $("#sliderModal").slick({
                adaptiveHeight: true,
                arrows: false,
                dots: true,
                initialSlide: 0,
                slidesToShow: 1
            });

            $("#modalSliderFire").click(() => {
                $("#sliderModal").slick('unslick');
                setTimeout(() => {
                    $("#sliderModal").slick({
                        adaptiveHeight: true,
                        arrows: false,
                        dots: true,
                        initialSlide: 0,
                        slidesToShow: 1
                    });
                    // $("#sliderModal").trigger("resize");
                }, 1);
            });

            $("#modalChoose").click(() => {

                $("#textAreaMessage").val(
                    $(".modal__slider__item.slick-active").find("div").html().replace(/(<([^>]+)>)/ig, "")
                );
            });
        }

        $('#ex2 select').on('change', function () {

            var serializedForm = $('#ex2 select').serializeArray();
            var url = $('#ex2').attr('data-url');

            $.ajax({
                method: "POST",
                url: url,
                beforeSend: function () {
                },
                data: serializedForm,
                success: function (response) {

                    var html = "";

                    if (response.status) {
                        console.log(response.felicitate);

                        $("#sliderModal").slick('unslick');

                        if (response.felicitate.length) {
                            $.each(response.felicitate, function (key, value) {
                                html += value.global_name.description.length ? '<div class="modal__slider__item"><div>' + value.global_name.description + '</div></div>' : '';
                            });
                        }
                        $('#sliderModal').html(html);

                        $("#sliderModal").slick({
                            adaptiveHeight: true,
                            arrows: false,
                            dots: true,
                            initialSlide: 0,
                            slidesToShow: 1
                        });
                    }
                },
                error: function () {
                }
            });
        });

        //tabs
        $(".tab").click(e => {
            let tab = e.currentTarget.classList[1];
            let content = $(".tab-content-" + tab[tab.length - 1]);
            if (!$(e.currentTarget).hasClass("tab-active")) {
                $(".tab-active").removeClass("tab-active");
                $(".tab-content-active").removeClass("tab-content-active");
                $(e.currentTarget).addClass("tab-active");
                $(content).addClass("tab-content-active");
            }
        });

        //google map
        if ($("#googleMap").length) {
            let latLong = new google.maps.LatLng(39.305, -76.617);
            let map = new google.maps.Map(document.getElementById("googleMap"), {
                center: latLong,
                zoom: 5
            });
        }

        $('.option-list input').on('change', function () {
            var option_price = 0;

            var list_option = $('.option-list input:checked');
            $.each(list_option, function (obj, option) {
                if ($(option).attr('data-price') !== '') {
                    option_price += parseInt($(option).attr('data-price'));
                }
            });

            var current_price = $('.current-price').attr('data-price');
            var delivery_price = $('#delivery-price').attr('data-price');

            $('.price-final').html(parseInt(option_price) + parseInt(current_price) + parseInt(delivery_price));

        });


        function readURL(input, thumbnail) {
            let countImage = 0;


//            let count_item = $('.review__image__item').length;
            /*
                        if (!count_item){
                            thumbnail.html('');
                        }
                        */

            let btnAdd = `<div class="review__image__add "><input type="file" name="image[]" class="upload-file review__image__add__input" multiple="multiple" accept="image/jpg,image/jpeg" data-component-id="38">+<p>png or jpg</p></div>`;

            $.each(input.files, function (key) {
                countImage += 1;
                if (countImage <= 5) {
                    if (input.files && input.files[key]) {
                        var reader = new FileReader();
                        var fileExention = getExtension(input.files[key].name);

                        reader.onload = function (e) {
                            if (fileExention === 'jpg' || fileExention === 'jpeg' || fileExention === 'png') {
                                thumbnail.prepend('<div class="review__image__item"><div class="review__image__container__close destroy-thumbnail" data-ident="' + testFile.length + '"></div><img src="' + e.target.result + '"></div></div>');
                            }
                        };
                        testFile[testFile.length] = input.files[key];

                        console.log(testFile.length);

                        reader.readAsDataURL(input.files[key]);
                    }
                }
            });
            setTimeout(function () {
//                    testFile = input.files;
            }, 300);
        }

        function getExtension(filename) {
            var parts = filename.split('.');

            return parts[parts.length - 1];
        }

        //    Upload file


        $(document).on('change', '.upload-file', function () {
            readURL(this, $('.thumbnail'));
        });

        //    Thumbnail file
        $(document).on('click', '.destroy-thumbnail', function () {
            let ident = $(this).attr('data-ident');
            var newTestFile = testFile;
            testFile = [];

            $.each(newTestFile, function (key, item) {
                if (key != ident) {
                    testFile[key] = item;
                }
            });

            $(this).parent().remove();
        });

        $interval = 0;

        $('#header-search-form input').on('keyup', function (evt) {

            $('.search__dropdown').html('');

            let element = $('.search__dropdown');
            $(element).removeClass('.search__dropdown-active');

            // $('#header-search-form').removeClass('.search__dropdown-active');

            clearInterval($interval);
            var e = evt || window.event;
            var key = e.which || e.keyCode;
            var validKeys = (
                key >= 50 && key <= 90 // numbers
                || key >= 96 && key <= 105 // num pad
                || key === 8 // backspace
                || key === 46 // delete
                || key === 33 // up
                || key === 34 // down
                || key === 40 // down
                || key === 38 // down
            );

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                validKeys = true;
            }

            if (validKeys) {
                if ($(this).val() == '') {
                    $('#header-searched-products').html('');
                    $('#go-header-search').removeClass('close');
                } else {
                    $('#go-header-search').addClass('close');
                    $('.searched-items').removeClass('hidden');
                }
                if (e.keyCode == 40 || e.keyCode == 38) {
                    var selected = $(".selected");
                    $(".searched-items li").removeClass("selected");
                    $(".searched-items li").removeClass("active");
                    if (e.keyCode == 38) {
                        $("#search").blur();// up
                        if (selected.prev().length == 0) {
                            selected.siblings().last().addClass("selected");
                            selected.siblings().last().addClass("active");
                        } else {
                            selected.prev().addClass("selected");
                            selected.prev().addClass("active");
                        }
                        $("#search").focus();
                    }
                    if (e.keyCode == 40) {
                        $("#search").blur();// down
                        if (selected.next().length == 0) {
                            selected.siblings().first().addClass("selected");
                            selected.siblings().first().addClass("active");
                        } else {
                            selected.next().addClass("selected");
                            selected.next().addClass("active");
                        }
                        $("#search").focus();
                    }
                } else if (e.keyCode == 13) {
                    var findedElement = $(".searched-items li.active").find('a');
                    if (findedElement.length > 0) {
                        window.location = findedElement.attr('href');
                    } else {
                        window.location = $('#viewAllSearch').attr('href');
                    }
                } else {
                    searched = this.value;
                    form = $('#header-search-form');
                    $interval = setTimeout(function () {
                        //call $.ajax here
                        $.ajax({
                            method: "POST",
                            url: `${window.location.origin}/${globalLang}/headerSearch`,
                            data: "searched=" + searched,
                            beforeSend: function () {
                            },
                        }).success(function (response) {
                            if (response.status) {
                                $('.search__dropdown').html(response.headerSearchedProducts);
                                $('.search__dropdown').addClass('search__dropdown-active');
                            } else {
                                $('.search__dropdown').html('');
                                $('.search__dropdown').removeClass('search__dropdown-active');
                            }
                        }).fail(function () {

                        });
                    }, 700);
                }
            }
        });
        // }
    });
})(jQuery);
